module.exports = __webpack_public_path__ + "media/icons/linkedin-light-5d325638.png";